
    <div class="appBottomMenu">
        <a (click)="openPage('/home')" class="item"
            [class]="(routerName=='/home' || routerName=='/home/'+deviceId) ? 'active':''">
            <div class="col">
                <ion-icon name="{{routerName=='/home' || routerName=='/home/'+deviceId ? 'home' : 'home-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'homeTap' | translate}}</h5>
            </div>
    
        </a>
        <a (click)="openPage('/wallet')" class="item" [class]="routerName=='/wallet'? 'active':''"
            *ngIf="isUserLoggedIn">
            <div class="col">
                <ion-icon name="{{routerName=='/wallet' ? 'wallet' : 'wallet-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'walletTap' | translate}}</h5>
            </div>
        </a>
    
        <a (click)="openPage('/promotion/list')" class="item" [class]="routerName=='/promotion/list'? 'active':''"
            *ngIf="isUserLoggedIn">
            <div class="col">
                <ion-icon name="{{routerName=='/promotion/list' ? 'megaphone' : 'megaphone-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'promotionTap' | translate}}</h5>
            </div>
        </a>
        <a (click)="openPage('/service/service-phone')" class="item"
            [class]="routerName=='/service/service-phone'? 'active':''">
            <div class="col">
                <ion-icon name="{{routerName=='/service/service-phone'  ? 'call' : 'call-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'serviceTap' | translate}}</h5>
            </div>
        </a>
        <a (click)="openPage('/profile/me-page')" class="item" [class]="routerName=='/profile/me-page'? 'active':''">
            <div class="col">
                <ion-icon name="{{routerName=='/profile/me-page'  ? 'person' : 'person-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'meTap' | translate}}</h5>
            </div>
        </a>
    
    </div>
